import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Button, Card, CardContent, CircularProgress, InputAdornment, TextField } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';

import { login } from '../api';
import { HINTERGRUND_OEFFENTLICH, Markenkopf } from '../komponenten/Bausteine';
import { fehlertext } from '../utils/format';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [passwort, setPasswort] = useState('');
  const [fehler, setFehler] = useState('');
  const [laedt, setLaedt] = useState(false);

  const anmelden = async (e) => {
    e.preventDefault();
    setLaedt(true);
    setFehler('');
    try {
      const r = await login(email, passwort);
      localStorage.setItem('portal_token', r.data.access_token);
      navigate('/uebersicht');
    } catch (err) {
      setFehler(fehlertext(err, 'Anmeldung fehlgeschlagen.'));
    } finally {
      setLaedt(false);
    }
  };

  return (
    <Box sx={HINTERGRUND_OEFFENTLICH}>
      <Card sx={{ width: '100%', maxWidth: 400, p: 1 }}>
        <CardContent sx={{ p: 3 }}>
          <Markenkopf titel="Lizenzportal" text="Melde dich an, um fortzufahren" />
          {fehler && <Alert severity="error" sx={{ mb: 2 }}>{fehler}</Alert>}
          <Box component="form" onSubmit={anmelden} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              id="login-email" label="E-Mail" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              required fullWidth autoFocus autoComplete="username"
              InputProps={{ startAdornment: <InputAdornment position="start"><EmailIcon sx={{ color: 'text.secondary', fontSize: 18 }} /></InputAdornment> }}
            />
            <TextField
              id="login-passwort" label="Passwort" type="password" value={passwort} onChange={(e) => setPasswort(e.target.value)}
              required fullWidth autoComplete="current-password"
              InputProps={{ startAdornment: <InputAdornment position="start"><LockIcon sx={{ color: 'text.secondary', fontSize: 18 }} /></InputAdornment> }}
            />
            <Button type="submit" variant="contained" fullWidth disabled={laedt} sx={{ mt: 0.5, py: 1.2 }}>
              {laedt ? <CircularProgress size={22} sx={{ color: '#1A1A1A' }} /> : 'Anmelden'}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
